import { render, staticRenderFns } from "./ykSwithTag.vue?vue&type=template&id=7da122ef&scoped=true"
import script from "./ykSwithTag.vue?vue&type=script&lang=js"
export * from "./ykSwithTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da122ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7da122ef')) {
      api.createRecord('7da122ef', component.options)
    } else {
      api.reload('7da122ef', component.options)
    }
    module.hot.accept("./ykSwithTag.vue?vue&type=template&id=7da122ef&scoped=true", function () {
      api.rerender('7da122ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YkFormComponet/ykSwithTag.vue"
export default component.exports